import Head from 'next/head'
import Header from './Header'
import Footer from './Footer'
import CommonHeadTags from './CommonHeadTags'
import ShadowCard from './ShadowCard'
import {
  GoogleAnalyticsHead,
  GoogleAnalyticsBody,
} from './GoogleAnalytics'
import styles from './Editorial.module.scss'
import { locales, localeHreflangs } from '../translations/config'

export default function EditorialLayout({
  title,
  description,
  path,
  eyebrow,
  updated,
  reviewedLabel = 'Reviewed and updated',
  locale = 'en',
  article = false,
  children,
}) {
  const localizedPath = locale === 'en' ? path : `/${locale}${path}`
  const url = `https://guitar-tuner.org${localizedPath}`
  const schema = article ? {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    datePublished: '2026-08-10',
    dateModified: '2026-08-15',
    inLanguage: localeHreflangs[locale],
    url,
    author: {
      '@type': 'Organization',
      name: 'ChordChord OÜ',
      url: 'https://guitar-tuner.org/about',
    },
    publisher: {
      '@type': 'Organization',
      name: 'Guitar-Tuner.org',
    },
    mainEntityOfPage: url,
  } : null

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='description' content={description} />
        <meta httpEquiv='content-language' content={localeHreflangs[locale]} />
        <link rel='canonical' href={url} />
        <link rel='alternate' hrefLang='x-default' href={`https://guitar-tuner.org${path}`} />
        {locales.map(item => <link key={item} rel='alternate' hrefLang={localeHreflangs[item]} href={`https://guitar-tuner.org${item === 'en' ? '' : `/${item}`}${path}`} />)}
        {schema && (
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
        )}
        {article && <meta property='article:published_time' content='2026-08-10' />}
        {article && <meta property='article:modified_time' content='2026-08-15' />}
        <CommonHeadTags
          title={title}
          description={description}
          url={url}
          type={article ? 'article' : 'website'}
        />
        <GoogleAnalyticsHead />
      </Head>

      <Header />
      <main className={styles.main}>
        <ShadowCard>
          <article className={styles.article}>
            {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
            <h1>{title}</h1>
            {updated && <p className={styles.updated}>{reviewedLabel} {updated}</p>}
            <p className={styles.lead}>{description}</p>
            {children}
          </article>
        </ShadowCard>
      </main>
      <Footer />
      <GoogleAnalyticsBody />
    </>
  )
}

export { styles as editorialStyles }
